import './App.scss';
import { Routes, Route } from 'react-router-dom';
import IntroLogin from './screens/introLogin/IntroLogin';
import drumRoutes from './screens/drumRoutes';
import AdminRouter from './Admin/AdminRouter';
import Hierarchy from './screens/Hierarchy';


function App() {

  return (
      <div className="App">

          <div className='Main'>

            <Routes>
              <Route path="/" element={<IntroLogin/>}/>
              {drumRoutes}
              <Route path="/admin/*" element={<AdminRouter/>}/>
              <Route path="/hierarchy" element={<Hierarchy/>}/>
            </Routes>
          </div>

      </div>
  );
}

export default App;
